import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isLongTitle } from '../../helpers';
import s from './Title.scss';
const Title = ({ title, showTitle, className })=>{
    const isMobile = useContext(MobileContext);
    if (!title || !showTitle) {
        return isMobile ? null : /*#__PURE__*/ React.createElement("div", {
            className: className
        });
    }
    return /*#__PURE__*/ React.createElement("h1", {
        className: classnames(s['root'], isLongTitle(title) && s['long'], className)
    }, title);
};
Title.displayName = 'Title';
export default Title;

//# sourceMappingURL=Title.js.map